import { useRequestGetEmployees } from '@/hooks/httpRequest';
import { ButtonFilterOptions } from '@/components/custom';
import { ISelectOption } from '@/interfaces';
import { useUrlParams } from '../hooks';

const ControlsFiltersAuthors = () => {

  const { isLoading: isLoadingEmployees, employees } = useRequestGetEmployees();
  const { authorIds, updateSearchParams } = useUrlParams();

  const selectOptions = (
    [...employees]
      .sort((a, b) => a.username > b.username ? 1 : -1)
      .map(
        l => ({
          title: l.username,
          value: l._id
        } as ISelectOption)
      )
  );

  const handleOnChangeFilter = (key: string, options: ISelectOption[]) =>
    updateSearchParams(
      prevUrlSearchParams => {
        // Get current values 
        const currentValues = prevUrlSearchParams.getAll(key);
        // Remove all existing
        currentValues.forEach(option => prevUrlSearchParams.delete(key, option));
        // Add new values        
        options.forEach(option => prevUrlSearchParams.append(key, option.value as string));
        // Return 
        return prevUrlSearchParams;
      }
    );

  return (
    <ButtonFilterOptions
      onChange={options => handleOnChangeFilter('authorIds', options)}
      disabled={isLoadingEmployees}
      options={selectOptions}
      value={authorIds}
      text='Auteurs'
      renderText={
        (text, options) => (
          <div className='flex items-center space-x-1'>
            <span>
              {text}
              {
                (options?.length ?? 0) !== 0 &&
                <span>
                  :
                </span>
              }
            </span>
            {
              (options?.length ?? 0) !== 0 &&
              <span className='text-purple-600'>
                (
                {
                  [...options]
                    .splice(0, 3)
                    .map(l => l.title)
                    .join(',')
                }
                {
                  options.length > 3 &&
                  <>
                    <span>
                      ,
                    </span>
                    <span className='font-semibold'>
                      +{options.length - 3}
                    </span>
                  </>
                }
                )
              </span>
            }
          </div>
        )
      } />
  );

};

export default ControlsFiltersAuthors;
